import { createSlice } from '@reduxjs/toolkit'

export const SuccessReducer = createSlice({
    name: 'successReducer',
    initialState: {
        successPage: false,
    },
    reducers: {
        setSuccessPage: (state, action) => { state.successPage = action.payload },
    },
})

// Action creators are generated for each case reducer function
export const { setSuccessPage } = SuccessReducer.actions

export default SuccessReducer.reducer